import styles from './index.module.css'
import { useEffect, useMemo, useRef, useState } from 'react'
import classNames from 'classnames'
import {
    useApplicationCodeMutation,
    useApplyCouponMutation,
} from '@/shared/api-rtk/api-list/cartApi.js'
import { TOAST_ERROR, TOAST_SUCCESS } from '@/shared/constants/toastTypes.js'

const PROMO_CONFIG = {
    voucher: {
        payloadKey: 'voucher',
        collapsedLabel: 'Применить сертификат',
        appliedLabel: 'Сертификат применён',
        placeholder: 'Введите код',
        buttonText: 'Применить',
    },
    coupon: {
        payloadKey: 'coupon',
        collapsedLabel: 'Купон со скидкой',
        appliedLabel: 'Купон применён',
        placeholder: 'Введите код',
        buttonText: 'Применить',
        description: '',
    },
}

export const PromoField = ({
    type = 'voucher',
    codeAplied,
    codeApplied,
    userInfo,
    collapsedLabel,
    appliedLabel,
    placeholder,
    buttonText,
    description,
    autoReload = true,
}) => {
    const ref = useRef(null)
    const appliedValue = codeApplied ?? codeAplied ?? ''
    const [toggle, setToggle] = useState(Boolean(appliedValue))
    const [codeValue, setCodeValue] = useState('')

    const [sendVoucher, voucherState] = useApplicationCodeMutation()
    const [sendCoupon, couponState] = useApplyCouponMutation()

    const { payloadKey, collapsedLabel: defaultCollapsed, appliedLabel: defaultApplied, placeholder: defaultPlaceholder, buttonText: defaultButton, description: defaultDescription = '' } =
        useMemo(() => PROMO_CONFIG[type] || PROMO_CONFIG.voucher, [type])

    const sendCodeMutation =
        type === 'coupon' ? [sendCoupon, couponState] : [sendVoucher, voucherState]
    const [sendCode, { isLoading }] = sendCodeMutation

    const currentCollapsedLabel = collapsedLabel ?? defaultCollapsed
    const currentAppliedLabel = appliedLabel ?? defaultApplied
    const currentPlaceholder = placeholder ?? defaultPlaceholder
    const currentButtonText = buttonText ?? defaultButton
    const currentDescription = description ?? defaultDescription

    useEffect(() => {
        setToggle(Boolean(appliedValue))
    }, [appliedValue])

    useEffect(() => {
        if (appliedValue) {
            setCodeValue(appliedValue)
        }
    }, [appliedValue])

    const onSubmit = async () => {
        if (!ref.current) {
            return
        }

        const value = ref.current.value.trim()

        if (!value) {
            TOAST_ERROR('Введите код')
            return
        }

        sendCode({ userInfo, [payloadKey]: value })
            .unwrap()
            .then((res) => {
                if (res.success) {
                    TOAST_SUCCESS(res.success)
                }
                if (!res.error && autoReload) {
                    window.location.reload()
                }
                if (res.error) {
                    TOAST_ERROR(res.error)
                }
            })
            .catch((err) => {
                TOAST_ERROR(err.message)
            })
    }

    useEffect(() => {
        if (toggle && !appliedValue) {
            ref.current?.focus()
        }
    }, [toggle, appliedValue])

    return (
        <div className={styles.wrapper}>
            <button
                onClick={() => setToggle(!toggle)}
                className={toggle ? styles.toggle : ''}
            >
                <span>
                    {appliedValue ? currentAppliedLabel : currentCollapsedLabel}
                </span>
                <img src={'/icons/arrow-carousel.svg'} alt={'arrow'} />
            </button>
            <div
                className={classNames(styles.content, toggle && styles.toggled)}
            >
                {currentDescription && <span>{currentDescription}</span>}
                <div className={styles.field}>
                    <input
                        disabled={Boolean(appliedValue)}
                        ref={ref}
                        value={
                            appliedValue && toggle ? appliedValue : codeValue
                        }
                        onChange={(e) => setCodeValue(e.target.value)}
                        type="text"
                        placeholder={currentPlaceholder}
                    />
                    <button
                        disabled={isLoading || Boolean(appliedValue)}
                        onClick={onSubmit}
                    >
                        {currentButtonText}
                    </button>
                </div>
            </div>
        </div>
    )
}
